import React, { useEffect, useState } from "react";
import { authFetch } from "@/App";

const cache = new Map();

// Protected images need the Bearer token, so they are fetched and displayed as blob URLs.
export function loadAuthBlobUrl(src) {
  if (!cache.has(src)) {
    const p = authFetch(src)
      .then((r) => (r.ok ? r.blob() : Promise.reject(new Error("image"))))
      .then((b) => URL.createObjectURL(b));
    p.catch(() => cache.delete(src));
    cache.set(src, p);
  }
  return cache.get(src);
}

export async function fetchAsDataUrl(src) {
  try {
    const res = await authFetch(src);
    if (!res.ok) return null;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

export function AuthImage({ src, alt = "", className = "", ...rest }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setUrl(null);
    setFailed(false);
    loadAuthBlobUrl(src).then((u) => active && setUrl(u)).catch(() => active && setFailed(true));
    return () => { active = false; };
  }, [src]);

  if (failed) return <div className={`${className} flex items-center justify-center bg-zinc-100 text-[10px] text-zinc-400`}>Indisponible</div>;
  if (!url) return <div className={`${className} animate-pulse bg-zinc-100`} />;
  return <img src={url} alt={alt} className={className} {...rest} />;
}
